<section class="container">
	<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">{{ 'client.disability.title' | transloco }}</h2>

	@if (hasClientsEditPermission()) {
		<div class="actions" data-testid="disability-actions">
			<lvr-button
				variant="primary"
				icon="add"
				[label]="'client.disability.add_proof_short' | transloco"
				[disabled]="disableAddProofButton()"
				(clicked)="openCreateProof()"
			></lvr-button>
			<lvr-button
				variant="primary"
				icon="add"
				[label]="'client.disability.add_type_short' | transloco"
				[disabled]="disableAddTypeButton()"
				(clicked)="openCreateType()"
			></lvr-button>
		</div>
	}

	<lvr-disability-proof-list
		[disabilityProofs]="paginatedProofs()"
		[totalItems]="proofTotalItems()"
		[pageSize]="proofPageSize()"
		[pageIndex]="proofPageIndex()"
		[showFirstLastButtons]="showFirstLastButtons"
		[hidePageSize]="hidePageSize"
		(pageChange)="handleProofPageEvent($event)"
	></lvr-disability-proof-list>
	<lvr-disability-type-list
		[disabilityTypes]="paginatedDisabilityKinds()"
		[totalItems]="typeTotalItems()"
		[pageSize]="typePageSize()"
		[pageIndex]="typePageIndex()"
		[showFirstLastButtons]="showFirstLastButtons"
		[hidePageSize]="hidePageSize"
		(pageChange)="handleTypePageEvent($event)"
	></lvr-disability-type-list>
</section>
